




















import { Component, Mixins } from 'vue-property-decorator';
import { Popup } from 'vant';
import Dialog from '@/mixins/Dialog';
import Box from '@/components/Box.vue';

@Component({
    components: {
        'van-popup': Popup,
        'box': Box
    }
})
export default class AnswerEndDialog extends Mixins(Dialog) {

    //标题
    public title_string: string = '';

    //提示
    public hint_string: string = '';

    //打开弹窗
    public openDialog(title: string, hint: string): void {
        this.title_string = title;
        this.hint_string = hint;
        this.show = true;
    }
}
